import ACTIONS, { FETCH_STATUS } from "../constants";

// ── List ─────────────────────────────────────────────────────────────────────
export const getReshuffleRequests = (payload) => ({
  type: ACTIONS.RESHUFFLE_REQUEST_CALL,
  payload,
});
export const getReshuffleRequestsAttempt = {
  pending: { type: ACTIONS.RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// FLAG RESHUFFLE_REQUEST

export const updateReshuffleRequestFlag = (state) => ({
  type: ACTIONS.RESHUFFLE_REQUEST_FLAG_CALL,
  payload: state,
});

export const updateReshuffleRequestFlagAttempt = {
  pending: {
    type: ACTIONS.RESHUFFLE_REQUEST_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RESHUFFLE_REQUEST_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RESHUFFLE_REQUEST_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// ── Create ───────────────────────────────────────────────────────────────────
export const createReshuffleRequest = (payload) => ({
  type: ACTIONS.CREATE_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const createReshuffleRequestAttempt = {
  pending: { type: ACTIONS.CREATE_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.CREATE_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.CREATE_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// ── Update ───────────────────────────────────────────────────────────────────
export const updateReshuffleRequest = (payload) => ({
  type: ACTIONS.UPDATE_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const updateReshuffleRequestAttempt = {
  pending: { type: ACTIONS.UPDATE_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.UPDATE_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.UPDATE_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// ── Delete ───────────────────────────────────────────────────────────────────
export const deleteReshuffleRequest = (payload) => ({
  type: ACTIONS.DELETE_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const deleteReshuffleRequestAttempt = {
  pending: { type: ACTIONS.DELETE_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.DELETE_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.DELETE_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// ── Submit ───────────────────────────────────────────────────────────────────
export const submitReshuffleRequest = (payload) => ({
  type: ACTIONS.SUBMIT_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const submitReshuffleRequestAttempt = {
  pending: { type: ACTIONS.SUBMIT_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.SUBMIT_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.SUBMIT_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// ── Approve ──────────────────────────────────────────────────────────────────
export const approveReshuffleRequest = (payload) => ({
  type: ACTIONS.APPROVE_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const approveReshuffleRequestAttempt = {
  pending: { type: ACTIONS.APPROVE_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.APPROVE_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.APPROVE_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// ── Reject ───────────────────────────────────────────────────────────────────
export const rejectReshuffleRequest = (payload) => ({
  type: ACTIONS.REJECT_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const rejectReshuffleRequestAttempt = {
  pending: { type: ACTIONS.REJECT_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.REJECT_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.REJECT_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// ── Execute ──────────────────────────────────────────────────────────────────
export const executeReshuffleRequest = (payload) => ({
  type: ACTIONS.EXECUTE_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const executeReshuffleRequestAttempt = {
  pending: { type: ACTIONS.EXECUTE_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.EXECUTE_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.EXECUTE_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

// ── Cancel ───────────────────────────────────────────────────────────────────
export const cancelReshuffleRequest = (payload) => ({
  type: ACTIONS.CANCEL_RESHUFFLE_REQUEST_CALL,
  payload,
});
export const cancelReshuffleRequestAttempt = {
  pending: { type: ACTIONS.CANCEL_RESHUFFLE_REQUEST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.CANCEL_RESHUFFLE_REQUEST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.CANCEL_RESHUFFLE_REQUEST.ERROR, error, status: FETCH_STATUS.ERROR }),
};
